import React from 'react';
var h = React.createElement;
import Model from 'pull-stream-model';
import _ from 'underscore';
import xtend from 'xtend';
import S from 'pull-stream';
import u from 'pull-stream-util';
var latest = u.combineLatest;
import ViewStream from '@invintus/react-pull-stream';
import Pushable from 'pull-pushable';
import many from 'pull-many';
import shouldUpdate from 'pull-stream-model/should-update';
import Notify from 'pull-notify';
import join from 'pull-flat-merge';
var r = {
    prop: require('ramda/src/prop'),
    apply: require('ramda/src/apply'),
    curry: require('ramda/src/curry')
};

import View from '../../ott/view/edit/index';
import OttEditModel from '../../ott/model/edit';
import Categories from '../../vast/edit/model/categories';
import req from '../../ott/lib/requests';
import Ev from '../../lib/event';
import PersistentStreamsModel from '../../ott/model/persistent-streams';
import AssetsModel from '../../ott/model/assets';
import queryString from '../../utils/QueryString';
import ErrorPage from '../../landing/error/Error';
import { hasPermission } from '../../lib/components/form/RestrictedComponent';
// import Log from '../../lib/log';

// fetch things
// take a key and an async function, return a stream
var request = r.curry(function (key, fn) {
    return _.compose(
        req.sandwich(key),
        req.fromCallback(
            _.compose(S.once, Ev('pushError')), // onErr
            _.compose(S.once, Ev(key), r.prop('data')) // onResp
        )
    )(fn);
});

var get = request('get');

function OttEditRoute (api, socket, opts, match) {
    // user auth
    if (!hasPermission('manage_ott.read,manage_ott.update')) {
        return function NotFound (props) {
            return h(ErrorPage, { code: 401 }, []);
        };
    }

    // var log = Log();
    var assetUpload = opts.assetUpload;
    var categoryModel = Model(Categories(api));
    var viewStream = ViewStream(View);
    var editModel = OttEditModel.store();
    var editEffects = OttEditModel.effects(xtend(api, {
        assetUpload: assetUpload
    }));

    var assetsWs = Pushable();
    socket.assets(function onMessage (msg) {
        if (msg.action.type === 'add' && msg.data) {
            assetsWs.push(Ev('add', msg.data));
        }
    });

    if (process.env.NODE_ENV === 'development') {
        window.push = viewStream.source.push;
    }

    var qsParams = queryString.parse(window.location.search);
    var channelID = qsParams.id;

    // multiple subsribers to view
    var viewSource = Notify();
    S( viewStream.source, S.drain(viewSource, viewSource.end) );

    var editState = S(
        many([
            // subscribe to view events
            S(
                u.sample.toArray(
                    editModel.state(),
                    viewSource.listen()
                ),
                S.map(editEffects),
                join()
            ),

            // fetch the channel by id
            S(
                (channelID ?
                    request('getChannelByID',
                        api.ott.getChannelByID.bind(api.ott, {
                            ottChannelID: channelID
                        })
                    ) :
                    S.empty()
                )
                // join()
            )
        ]),

        // S.through(console.log.bind(console, 'event')),
        // S.through(log.push.bind(log)),

        editModel() // all these events go into the store
    );

    var states = S(
        latest({
            edit: editState,

            persistentStreams: S(
                get(api.feeds.getPersistent),
                PersistentStreamsModel.store()
            ),

            assets: S(
                S.many([
                    get(api.assets.getMiscAssets.bind(api.assets, {
                        advancedDetails: true
                    })),

                    assetsWs
                ]),

                AssetsModel.store()
            ),

            categories: S(
                S.once(categoryModel.msg.get()),
                categoryModel.effects(),
                categoryModel.store
            )
        })
    );

    function toArray (sortProp, array) {
        return _.sortBy( _.toArray(array), sortProp );
    }
    
    S(
        states,

        S.map(function (state) {
            const assets = xtend(state.assets, {
                data: toArray('name', state.assets.data)
                    .filter(function (asset) {
                        return asset.type === 'image';
                    })
            })
            return xtend(state.edit, {
                categories: xtend(state.categories, {
                    data: toArray('categoryName', state.categories.data)
                }),
                persistentStreams: xtend(state.persistentStreams, {
                    data: toArray('title', state.persistentStreams.data)
                }),
                assets,
                loading: !state.categories.hasFetched ||
                    state.persistentStreams.resolving.length > 0 ||
                    assets.data.length === 0 ,
                selectedDefaultImage: _(state.assets.data)
                    .findWhere({
                        assetID: state.edit.selectedDefaultImage
                    })
            });
        }),

        shouldUpdate(function (prev, next) {
            if (prev === null) return true;
            return !(prev.categories.resolving.length > 0 &&
                next.categories.resolving.length > 0);
        }),
        // S.through(console.log.bind(console, 'state')),
        viewStream.sink
    );

    return viewStream.view;
}

export default OttEditRoute;
